// Brand gradient constants used throughout the application
export const FILL_GRADIENT = 'linear-gradient(90deg, #FCB902 0%, #FF00CF 100%)'
export const LINE_GRADIENT = 'linear-gradient(90deg, rgb(252, 131, 2) 0%, #FF00CF 100%)'

